@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
    width: 100%;
}

// Shadow DOM does not inherit the page's Bootstrap reboot, so the relevant
// element resets the light-DOM markup relies on are copied here from
// `bootstrap/4.0.0-beta.2` reboot.
*,
*::before,
*::after {
    box-sizing: border-box;
}

img {
    vertical-align: middle;
    border-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}

a {
    text-decoration: none;
    background-color: transparent;
}

// Video item — ported from `video_item_media.html`'s `.video-item` markup.
// Merges the "new design" base (`vumedi-theme.scss`) with the `custom.scss`
// overrides that win in the cascade (custom.scss loads after vumedi-theme).
.video-item {
    display: flex;
    width: 100%;
    padding: 4px;

    @include mixins.max-screen(variables.$smd) {
        flex-direction: column;

        .video-item__img-container {
            margin: 0;
            margin-bottom: 16px;
        }
    }

    &__img-container {
        position: relative;
        margin-right: 20px;
        max-width: 300px;
        max-height: 170px; /* Needed for proper item overlay placement */
    }

    &__img-container-center {
        /* For proper Channel, Event image display (images are not cropped) */
        min-width: 300px;
        min-height: 170px;
        // Reset max-height since images are scaled to 300px width, not cropped.
        max-height: none;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;

        a:hover {
            text-decoration: none;
        }
    }

    &__img {
        max-width: 300px;
    }

    &__img-placeholder {
        min-height: 120px;
        min-width: 120px;
    }

    &__info {
        width: 100%;
        // `d-flex flex-column align-items-start` from the template markup.
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    &__author {
        margin-top: 4px;
        margin-bottom: 2px;
        width: 100%;
        font-family: variables.$fontPrimary;
        font-size: 15px;
        letter-spacing: 0.4px;
        text-align: left;
        text-transform: uppercase;
        color: #8b8d92;

        a {
            color: #8b8d92;
        }
    }

    &__title {
        margin-bottom: 4px;
        width: 100%;
        font-family: variables.$fontPrimary;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.4;
        letter-spacing: 0.1px;
        text-align: left;
        color: #20262b;

        a {
            color: #20262b;

            &:hover {
                color: #0092db;
                text-decoration: none;
            }
        }
    }

    &__desc {
        width: 100%;
        font-family: variables.$fontPrimary;
        font-size: 14px;
        letter-spacing: 0.1px;
        text-align: left;
        color: #8b8d92;

        a,
        .contributor-text {
            color: #4f4f4f;
            font-weight: normal;
            text-transform: uppercase;
        }
    }

    // Stats-row wrapper. Like the other info-column children it must be full
    // width (the column is `align-items: flex-start`, so without this it would
    // shrink-wrap and the `pull-right` date would float to the wrong edge).
    &__meta {
        width: 100%;
    }
}

// Spacing / list utilities used by the stats row (`content_views_long.html`
// markup) — ported from Bootstrap (`_spacing.scss` + the list utilities) since
// the shadow DOM does not inherit the page's utility classes.
.mt-2 {
    margin-top: 0.5rem !important;
}

.list-inline {
    padding-left: 0;
    list-style: none;
}

.list-inline-item {
    display: inline-block;
}

.mr-2 {
    margin-right: 0.5rem !important;
}

.pull-right {
    float: right !important;
}

.d-inline {
    display: inline !important;
}

.text-muted {
    color: #868e96 !important;
}

// Font Awesome 4.7 glyphs used by the stats row. The `@font-face` is registered
// at the document level (base.html loads `font-awesome.min.css`), and document
// fonts resolve inside the shadow DOM, so only the icon rules are needed here.
.fa {
    display: inline-block;
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
}

.fa-eye::before {
    content: "\f06e";
}

.fa-calendar::before {
    content: "\f073";
}

.fa-thumbs-o-up::before {
    content: "\f087";
}

/* Overlay on images — ported from `.overlay` / `.overlay.video-duration`. */
.overlay {
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 12px;
    background-color: black;
    color: white;
    line-height: 14px;
    opacity: 0.75;
    font-weight: bold;
    padding: 0 4px;
    display: inline-block;
}

.overlay.video-duration {
    display: inline-block;
    border-radius: 20px;
    padding: 2px 6px;
}

.overlay.info-overlay {
    background-color: #efefef;
    color: #111;
}

a:hover .overlay {
    display: none;
}

a:hover .overlay.video-duration {
    display: inline-block;
}
